import { render } from "./F2Icon.vue?vue&type=template&id=3f153d47&scoped=true&ts=true"
import script from "./F2Icon.vue?vue&type=script&lang=ts"
export * from "./F2Icon.vue?vue&type=script&lang=ts"

import "./F2Icon.vue?vue&type=style&index=0&id=3f153d47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f153d47"]])

export default __exports__